import React, { useEffect, useState } from "react";
import "./Members.css";
import axios from "axios";

const Members = () => {
  const [response, setResponse] = useState(null);
  const [filters, setFilters] = useState([]);
  const [activeFilters, setActiveFilters] = useState([]);
  const [filteredPosts, setFilteredPosts] = useState([]);

  const fetchMembers = async () => {
    try {
      const response = await axios.get(
        `https://www.railcargo.nl/en/wp-json/wp/v2/posts?categories=${
          activeFilters.length <= 0 ? 47 : activeFilters.join(",")
        }`
      );
      setResponse(response.data);
      setFilteredPosts(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchMembers();
  }, [activeFilters, activeFilters]);

  const toggleFilter = (filter) => {
    if (activeFilters.includes(filter)) {
      setActiveFilters(activeFilters.filter((item) => item !== filter));
    } else {
      setActiveFilters([...activeFilters, filter]);
    }
  };

  const handleSearch = (query) => {
    const filteredPosts = response?.filter((response) =>
      response?.title.rendered.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredPosts(filteredPosts);
  };

  return (
    <div className="members-overview-rc">
      <div className="background-header"></div>
      <div className="search-filter-container">
        <img
          src="https://railcargo.nl/wp-content/uploads/2023/09/railcargo-icon_01.svg"
          alt="railcargo-logo"
          className="filters-railcargo-logo"
        />
        <h1 className="filters-main-header">News & Best Practices</h1>
        <div className="search-bar">
          <input
            type="text"
            placeholder="Search for article"
            onChange={(e) => handleSearch(e.target.value)}
          />
          <i className="fa-solid fa-magnifying-glass"></i>
        </div>
        <p className="filters-header">
          <b>Specify your search</b>
        </p>
        <div className="filters">
          <div
            className={
              activeFilters.includes(47) ? "active-filter filter" : "filter"
            }
            onClick={() => toggleFilter(47)}
          >
            <span>Best Practices</span>
            <div className="cancel-filter">
              <i className="fa-solid fa-plus"></i>
            </div>
          </div>
          <div
            className={
              activeFilters.includes(56) ? "active-filter filter" : "filter"
            }
            onClick={() => {
              toggleFilter(56);
            }}
          >
            <span>News</span>{" "}
            <div className="cancel-filter">
              <i className="fa-solid fa-plus"></i>
            </div>
          </div>
        </div>
      </div>
      <div className="container members-container">
        <div className="row g-4">
          {filteredPosts?.map((item, index) => (
            <div className="col-lg-4 col-md-6 col-xxl-4" key={index}>
              <a className="member-card" href={item.link}>
                <img
                  src={item.yoast_head_json.og_image[0].url}
                  alt="bg-img"
                  className="bg-card-img"
                />

                <span className="member-hashtag">{item.acf.hashtag}</span>
                <p className="member-title">{item.title.rendered}</p>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Members;
